// extracted by mini-css-extract-plugin
export default {"Snineth":"Snineth_Snineth__tQ8fL","wrap":"Snineth_wrap__Hh46o","text":"Snineth_text__UI8O1","title":"Snineth_title__oFjT-","desc":"Snineth_desc__4jowJ","img":"Snineth_img__GJdGZ"};